import { DetailDirective } from './../detail.directive';
import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy, ComponentFactoryResolver, Input } from '@angular/core';

@Component({
    selector: 'app-detail-placeholder',
    templateUrl: './detail-placeholder.component.html',
    styleUrls: ['./detail-placeholder.component.css']
})
export class DetailPlaceholderComponent implements OnInit {

    ngOnInit() {

    }

}
